import React, { useState } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import StudentVacationFormBody from './StudentVacationFormBody';
import './GroupForm.css';

const StudentVacationForm: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { studentId, vacationId } = useParams<{ studentId: string; vacationId: string }>();

  const isCreate = !vacationId;
  const prefillStudentId = searchParams.get('studentId');
  const [editStudentName, setEditStudentName] = useState('');

  const effectiveStudentId = isCreate
    ? (prefillStudentId ? parseInt(prefillStudentId, 10) : undefined)
    : (studentId ? parseInt(studentId, 10) : undefined);

  const goBack = () => navigate('/student-vacations');
  const title = isCreate ? 'Add Student Vacation' : 'Edit Student Vacation';

  return (
    <div className="group-form-container">
      <div className="page-header">
        <div className="page-header-content">
          <h1>{title}</h1>
          {!isCreate && editStudentName && <p>{editStudentName}</p>}
          {isCreate && <p>Select a student and vacation period</p>}
        </div>
      </div>

      <div style={{ margin: '0 2rem' }}>
        <StudentVacationFormBody
          studentId={effectiveStudentId}
          vacationId={vacationId ? parseInt(vacationId, 10) : undefined}
          lockStudent={Boolean(prefillStudentId)}
          onSuccess={goBack}
          onCancel={goBack}
          onDeleted={goBack}
          onStudentLoaded={setEditStudentName}
        />
      </div>
    </div>
  );
};

export default StudentVacationForm;
